import React from "react";
import { Box, Typography } from "@mui/material";
import { styled } from "@mui/system";

// Styled Component for Title Bar with Theme-Based Background
const TitleBar = styled(Box)(({ theme }) => ({
  background: theme.palette.background.paper, // Match with paper background
  padding: "16px 24px",
  borderRadius: "16px", // Rounded corners
  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)", // Soft shadow for depth
  maxWidth: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  marginBottom: "20px", // Margin below the title
  border: `2px solid ${
    theme.palette.mode === "dark"
      ? theme.palette.primary.dark
      : theme.palette.primary.main
  }`, // Border based on theme
}));

const Title = ({ text, icon }) => {
  return (
    <TitleBar>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          color: (theme) =>
            theme.palette.mode === "dark"
              ? theme.palette.primary.dark
              : theme.palette.primary.main, // Text & icon color
        }}
      >
        {icon && <Box>{icon}</Box>}
        <Typography
          variant="h6"
          fontWeight="bold"
          sx={{
            color: (theme) =>
              theme.palette.mode === "dark"
                ? theme.palette.primary.dark
                : theme.palette.primary.main, // Match text color to theme
          }}
        >
          {text}
        </Typography>
      </Box>
    </TitleBar>
  );
};

export default Title;
